module.exports = __webpack_public_path__ + "img/ai.1ff8ed3b.png";